import { venueAvailabilityView } from 'core/telemetry/avo/Avo';

export const telemetryVenueAvailabilityView = () => {
  venueAvailabilityView({
    durationMs: 0,
  });
};
